import { useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Row from "@amzn/meridian/esm/components/row";
import Select, { SelectOption } from "@amzn/meridian/esm/components/select";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { PILL_RADIUS_FILL } from "../../constants";
import {
  ALL_ORGS_LABEL,
  ALL_ORGS_VALUE,
  ORG_COLOR_MARKER_SIZE,
} from "./whosWho.constants";

const formatOrgCountLabel = (label, count) => `${label} (${count})`;

const renderOrgLabel = (org, count, color) => (
  <Row spacing="200" alignmentVertical="center">
    <Theme
      tokens={{
        boxBorderRadiusFill: PILL_RADIUS_FILL,
        boxBorderColorFill: color,
      }}
    >
      <Box
        aria-hidden="true"
        type="fill"
        backgroundColor={color}
        width={ORG_COLOR_MARKER_SIZE}
        minWidth={ORG_COLOR_MARKER_SIZE}
        height={ORG_COLOR_MARKER_SIZE}
      />
    </Theme>
    <Box>{formatOrgCountLabel(org, count)}</Box>
  </Row>
);

const WhosWhoOrgSelect = ({ orgs, orgColorMap, orgCounts, totalCount, activeOrg, onSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const normalizedQuery = searchQuery.trim().toLocaleLowerCase();
  const allOrgsLabel = formatOrgCountLabel(ALL_ORGS_LABEL, totalCount);
  const allOptionMatches = !normalizedQuery
    || ALL_ORGS_LABEL.toLocaleLowerCase().includes(normalizedQuery);
  const matchingOrgs = normalizedQuery
    ? orgs.filter((org) => org.toLocaleLowerCase().includes(normalizedQuery))
    : orgs;
  const hasMatches = allOptionMatches || matchingOrgs.length > 0;

  return (
    <Select
      aria-label="Filter by organization"
      size="small"
      searchQuery={searchQuery}
      onSearch={setSearchQuery}
      placeholder="Search organizations"
      value={activeOrg ?? ALL_ORGS_VALUE}
      valueLabel={() => activeOrg
        ? renderOrgLabel(activeOrg, orgCounts[activeOrg], orgColorMap[activeOrg])
        : allOrgsLabel}
      onChange={(value) => onSelect(value === ALL_ORGS_VALUE ? null : value)}
      width="100%"
    >
      {allOptionMatches && (
        <SelectOption value={ALL_ORGS_VALUE} label={allOrgsLabel} />
      )}
      {matchingOrgs.map((org) => {
        const label = formatOrgCountLabel(org, orgCounts[org]);
        return (
          <SelectOption key={org} value={org} label={label}>
            {() => renderOrgLabel(org, orgCounts[org], orgColorMap[org])}
          </SelectOption>
        );
      })}
      {!hasMatches && (
        <Box spacingInset="400">
          <Text>No matching organizations</Text>
        </Box>
      )}
    </Select>
  );
};

export default WhosWhoOrgSelect;
